export enum BUTTON_STYLE {
	DEFAULT = '',
	PRIMARY = 'button-primary',
	WARNING = 'button-warning',
}
